import React from 'react';
import '../../App.css';

export default function Factuur() {
    return <h1 className='factuur' style={{ backgroundImage: `url("images/img-2.jpg")`}}>Factuur</h1>;
}